module.exports = __webpack_public_path__ + "images/index/nsac.c5b66f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect/nsac.jpg
// module id = YRAB
// module chunks = 21